/** Display projections of immutable payment/refund rows; server admission is atomic SQL. */
type PaymentAmount = { id: string; kind: string; amount: number; status: string; refundOfPaymentId: string | null };

export function refundableAmount(original: PaymentAmount, payments: PaymentAmount[]): number {
  if (original.kind === "refund" || original.status !== "succeeded") return 0;
  const reserved = payments.filter(p => p.kind === "refund" && ["pending", "succeeded"].includes(p.status) && (p.refundOfPaymentId === original.id || p.refundOfPaymentId === null)).reduce((sum, p) => sum + p.amount, 0);
  return Math.max(0, original.amount - reserved);
}

export function damageCollected(payments: PaymentAmount[]): number {
  const damageIds = new Set(payments.filter(p => p.kind === "damage_deposit").map(p => p.id));
  return payments.filter(p => p.status === "succeeded").reduce((sum, p) => sum + (p.kind === "damage_deposit" ? p.amount : p.kind === "refund" && p.refundOfPaymentId && damageIds.has(p.refundOfPaymentId) ? -p.amount : 0), 0);
}
